import Vue from 'vue'
import Vuex from 'vuex'

import api from '../api/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    uuid: '',    
    options: null, //параметры от клиента
    widgetConfig: null //параметры от сервера
  },
  mutations: {
    SET_WIDGET_CONFIG(state, widgetConfig) {
      state.widgetConfig= widgetConfig
    },
    SET_WIDGET_OPTIONS(state, options) {
      state.options = options
    },
    SET_WIDGET_UUID(state, uuid) {
      state.uuid = uuid
    }
  },
  actions: {
    INIT_WIDGET({ state, commit }, {options, uuid}) {

      commit('SET_WIDGET_UUID', uuid)
      commit("SET_WIDGET_OPTIONS", options)

      function getWidgetTypeId(widgetTypeName) {
        switch (widgetTypeName) {
          case 'payments':
            return 1
          case 'counters':
            return 2
          case 'one-form':
              return 3
          default:
            return 1
        }
      }

      if (!state.options.providerGuid) {
        console.error('provider guid not defined')
        return
      }

      let widgetTypeId =  getWidgetTypeId(state.options.widgetType)
      return api.getParams(state.options.providerGuid,  widgetTypeId.toString())
        .then(widgetConfig=> {
            commit('SET_WIDGET_CONFIG', widgetConfig)
           
        })
    },

    RELOAD_WIDGET({state, commit}) {

      function getWidgetTypeId(widgetTypeName) {
        switch (widgetTypeName) {
          case 'payments':
            return 1
          case 'counters':
            return 2
          case 'one-form':
            return 3
          default:
            return 1
        }
      }

      let widgetTypeId =  getWidgetTypeId(state.options.widgetType)
      return api.getParams(state.options.providerGuid,  widgetTypeId.toString())
      .then(widgetConfig=> {
          commit('SET_WIDGET_CONFIG', widgetConfig)
      })
    }
  },
  modules: {
  }
})
